import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FootrComponent } from '../footr/footr.component'; // Adjust the path as necessary
import { LandingmenuComponent } from '../landingmenu/landingmenu.component';
//import { FiledropPopupComponent } from '../filedrop-popup/filedrop-popup.component';

@NgModule({
  declarations: [
    LandingmenuComponent,
    //FiledropPopupComponent
  ],
  imports: [
    CommonModule,
    FootrComponent
  ],
  exports: [
    FootrComponent,
    LandingmenuComponent,
  //  FiledropPopupComponent
  ]
})
export class LandingsharedModule { }